import { useEffect, useState } from 'react'

/** Nhịp mặc định: nửa phút, đủ mịn cho một bảng treo tường. */
const DEFAULT_INTERVAL_MS = 30_000

/**
 * Mốc "bây giờ" tự làm mới theo nhịp.
 *
 * Cần cho những màn hình chạy suốt ca mà nội dung phụ thuộc đồng hồ: vạch
 * "bây giờ" và các con số đếm ngược. Nếu chỉ gọi `new Date()` trong thân
 * component thì nó chỉ đổi khi có thứ khác làm component render lại — trên máy
 * trạm là lúc có sự kiện SSE hoặc lúc query làm mới, tức là số có thể cũ hàng
 * phút mà nhìn vẫn như thật.
 */
export function useNow(intervalMs: number = DEFAULT_INTERVAL_MS): Date {
    const [now, setNow] = useState(() => new Date())

    useEffect(() => {
        const timer = setInterval(() => setNow(new Date()), intervalMs)
        return () => clearInterval(timer)
    }, [intervalMs])

    return now
}
